import Styled from 'styled-components';

export const Container = Styled.div`
display: flex;
align-items: center;
justify-content: start;

`;
export const Label = Styled.label`
font-size: ${props => props.theme.fontSize.small};
`;
export const InputMediu = Styled.input`
  height: 14%;
  border: 1px solid;
  border-radius: 5px;
  background: transparent;
  border-color: ${props => props.theme.colors.secundary};
  display:flex;
  padding-left: 5px;
  font-size: ${props => props.theme.fontSize.mediun};

  :focus{
    border-color: ${props => props.theme.focusInput.color} !important;
    
 
  }
`;
